import subtractDays from './subtract-days';

export { subtractDays };

export default subtractDays;
